module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium.4d10e37e.woff";